module.exports = "<header class=\"modal-header\">\n  <h4 class=\"modal-title\" data-i18n=\"dashboard.demoUserDialog.title\"></h4>\n</header>\n\n<div class=\"modal-body padding-body scrollable\" dc-scrollbar>\n  <div class=\"padding-body\" data-i18n=\"dashboard.demoUserDialog.text\">\n  </div>\n</div>\n\n<div class=\"modal-footer\">\n  <button class=\"btn btn-primary\" ng-click=\"$close();\" data-i18n=\"common.buttons.ok\"></button>\n\n  <button class=\"btn btn-default\" ng-click=\"$dismiss();\" data-i18n=\"common.buttons.cancel\"></button>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/ui/modules/dc-ui/dc-modal/demoUserDialog.tpl.html
// module id = 476
// module chunks = 12